import React from 'react';
import { Box, HStack, Text, IconButton } from '@chakra-ui/react';
import { ChevronDownIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import { trackingService } from '../../../../shared/eventTracking';

interface MobileHeaderProps {
  isRecording: boolean;
  setIsMinimized: (minimized: boolean) => void;
  setInternalIsOpen: (open: boolean) => void;
  handleClose: () => void;
}

function MobileHeader({ isRecording, setIsMinimized, setInternalIsOpen, handleClose }: MobileHeaderProps) {
  const handleMinimize = () => {
    if (isRecording) {
      trackingService.trackPrescriptionVoiceWindowToggle('minimize');
      setIsMinimized(true);
    } else {
      setInternalIsOpen(false);
    }
  };

  return (
    <Box p="16px" pt="calc(env(safe-area-inset-top) + 16px)" borderBottom="1px solid" borderColor="gray.100" bg="white">
      <HStack justify="space-between" align="center">
        {/* Botão Voltar/Cancelar */}
        <HStack spacing="8px" align="center" cursor="pointer" onClick={handleClose}>
          <IconButton
            aria-label="Voltar"
            icon={<ChevronLeftIcon boxSize="24px" />}
            size="sm"
            variant="ghost"
            color="purple.600"
            _hover={{ bg: 'purple.50' }}
          />
          <Text fontSize="16px" fontWeight="500" color="purple.600">
            Voltar
          </Text>
        </HStack>

        {/* Botão Minimizar */}
        <IconButton
          aria-label="Minimizar"
          icon={<ChevronDownIcon boxSize="24px" />}
          size="sm"
          variant="ghost"
          color="purple.600"
          _hover={{ bg: 'purple.50' }}
          onClick={handleMinimize}
        />
      </HStack>
    </Box>
  );
}

export { MobileHeader };
